


import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import galleryIcon from "../../../src/assests/images/gallaryIcon.svg";
import Upload from "../../../src/assests/images/document-upload.svg";
import { getToken } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { uploadimagetask } from "../../pages/create-task/api";
import LinearProgress from "@mui/material/LinearProgress";
import { useTaskContext } from "../store/AlltasksContext";

interface CreatetaskImg3Props {
  setuploadedImage?: (image: string) => void;
  mainIdd: number;
  id: number;
  headTitle?: string;
  title?: string;
  subtitle?: string;
  note?: string;
  uploadText?: string;
  maintitle?: string;
  handleAction?: (id: number) => void;
  uploadSize?: string;
  addMoreText?: string;
  onClick?: () => void;
  imageUrls?: string[];
  lang: {
    addMore?: string;
    [key: string]: any;
  };
  setIconImage?: React.Dispatch<React.SetStateAction<string>>;
  iconImage?: string;
}

function CreatetaskImg3({
  setuploadedImage,
  mainIdd,
  id,
  headTitle,
  title,
  subtitle,
  note,
  uploadText,
  maintitle,
  handleAction,
  uploadSize,
  addMoreText,
  onClick,
  imageUrls = [],
  lang,
  setIconImage,
  iconImage,
}: CreatetaskImg3Props) {
  const [keyVisualFiles, setKeyVisualFiles] = useState<
    { id: number; file: File; preview: string; imageUrl: string }[]
  >([]);
  const navigate = useNavigate();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploadProgress, setUploadProgress] = useState<{
    [fileName: string]: number;
  }>({});

  const token = getToken();
  const {
    setfileName,
    fileName,
    setfinalll,
    finalll,
    setimagesdata3,
    imagesdata3,
    Tabname,
    setFiles4,
    files4,
    selectedmcq,
    currentData,
  } = useTaskContext();

  // Comment out or condition the reset to prevent data loss
  // useEffect(() => {
  //   setimagesdata3([]);
  // }, [Tabname, setimagesdata3]);

const handleDrop = async (
  acceptedFiles: File[],
  setter: React.Dispatch<
    React.SetStateAction<
      { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
    >
  >,
  mainIdd: number
) => {
  if (acceptedFiles.length === 0 || !mainIdd) return;

  setIsUploading(true);
  setUploadError(null);

  try {
    const uploadedFiles = await Promise.all(
      acceptedFiles.map(async (file) => {
        const formData = new FormData();
        formData.append("answer", file);

        const onUploadProgress = (progressEvent: import("axios").AxiosProgressEvent) => {
          if (progressEvent.total) {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress((prev) => ({
              ...prev,
              [file.name]: progress,
            }));
            console.log(`File: ${file.name}, Progress: ${progress}%`);
          }
        };

        const response = await uploadimagetask(formData, token);

        if (response?.data?.answer) {
          const imageUrl = response.data.answer;
          // Only update iconImage if explicitly needed
          if (setIconImage && !iconImage) {
            setIconImage(imageUrl);
          }
          return {
            id: mainIdd,
            file,
            preview: URL.createObjectURL(file),
            imageUrl,
          };
        } else {
          return null;
        }
      })
    );

    const successfulUploads = uploadedFiles.filter(
      (file): file is { id: number; file: File; preview: string; imageUrl: string } =>
        file !== null
    );

    // Update imagesdata3
    setimagesdata3((prevImagesData) => {
      const existingEntry = prevImagesData.find((entry) => entry.id === mainIdd);
      if (existingEntry) {
        return prevImagesData.map((entry) =>
          entry.id === mainIdd
            ? {
                ...entry,
                images: [...entry.images, ...successfulUploads.map((file) => file.imageUrl)],
              }
            : entry
        );
      } else {
        return [
          ...prevImagesData,
          { id: mainIdd, images: successfulUploads.map((file) => file.imageUrl) },
        ];
      }
    });

    // Update files4
    setter((prevFiles4) => {
      const existingEntry = prevFiles4.find((entry) => entry.id === mainIdd);
      if (existingEntry) {
        return prevFiles4.map((entry) =>
          entry.id === mainIdd
            ? {
                ...entry,
                files: [...entry.files, ...successfulUploads],
              }
            : entry
        );
      } else {
        return [
          ...prevFiles4,
          { id: mainIdd, files: successfulUploads },
        ];
      }
    });
  } catch (error) {
    console.error("Upload error:", error);
    setUploadError("Upload failed. Please try again.");
  } finally {
    setIsUploading(false);
  }
};

  const handleRemoveFile = (
    index: number,
    setter: React.Dispatch<
      React.SetStateAction<
        { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
      >
    >,
    mainIdd: number
  ) => {
    setter((prev) => {
      const updatedFiles4 = prev
        .map((entry) =>
          entry.id === mainIdd
            ? { ...entry, files: entry.files.filter((_, i) => i !== index) }
            : entry
        )
        .filter((entry) => entry.files.length > 0);

      // Update imagesdata3
      setimagesdata3((prevImagesData) => {
        return prevImagesData
          .map((entry) =>
            entry.id === mainIdd
              ? { ...entry, images: entry.images.filter((_, i) => i !== index) }
              : entry
          )
          .filter((entry) => entry.images.length > 0);
      });

      return updatedFiles4;
    });
  };

  const renderThumbnails = (
    files: { id: number; file: File; preview: string; imageUrl: string }[],
    setter: React.Dispatch<
      React.SetStateAction<
        { id: number; files: { id: number; file: File; preview: string; imageUrl: string }[] }[]
      >
    >,
    mainIdd: number
  ) =>
    files.map((file, index: number) => {
      const isVideo = file.file?.type?.startsWith("video") || false;
      const progress = uploadProgress[file.file?.name || file.preview];
      return (
        <Box
          key={index}
          sx={{
            position: "relative",
            width: 100,
            height: 100,
            margin: 1,
            border: "1px solid #ccc",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {isVideo ? (
            <video
              src={file.preview}
              controls
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <img
              src={file.preview}
              alt="Preview"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
          <Button
            size="small"
            variant="contained"
            color="error"
            sx={{
              position: "absolute",
              top: 5,
              right: 5,
              minWidth: 24,
              width: 24,
              height: 24,
              padding: 0,
              borderRadius: "50%",
            }}
            onClick={() => handleRemoveFile(index, setter, mainIdd)}
          >
            ×
          </Button>
          {progress !== undefined && (
            <Box sx={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{ height: 6, borderRadius: 0 }}
              />
              <Typography
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: 8,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  fontSize: "12px",
                  padding: "2px 6px",
                  borderRadius: "4px",
                }}
              >
                {progress}%
              </Typography>
            </Box>
          )}
        </Box>
      );
    });

  const handleDropRejected = (fileRejections: any) => {
    fileRejections.forEach((file: any) => {
      if (file?.file?.size > 10 * 1024 * 1024) {
        setUploadError("File size should not exceed 10MB.");
      } else {
        setUploadError("File type or size is not supported.");
      }
    });
  };

  const { getRootProps: getRootPropsMain, getInputProps: getInputPropsMain } = useDropzone({
    onDrop: (files: any) => {
      setUploadError(null);
      handleDrop(files, setFiles4, mainIdd);
    },
    onDropRejected: handleDropRejected,
    accept: { "image/*": [], "video/*": [] },
    maxSize: 10 * 1024 * 1024,
    multiple: false,
  });
console.log(imagesdata3, "imagesdata3imagesdata333333333")
  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: "0 0px" }}>
      <Typography
        variant="h3"
        sx={{
          fontSize: "24px",
          fontWeight: "600",
          color: "#000",
          margin: "20px 0 20px",
          width: "100%",
        }}
      >
        {headTitle}
      </Typography>
      {/* <Typography variant="h6" sx={{ fontSize: "18px", display: "flex" }}>
        <img
          style={{ marginRight: "8px", marginTop: "0px" }}
          src={Upload}
          alt="upload image"
        />
        {title}
      </Typography> */}
      {/* <Typography
        variant="body1"
        sx={{ fontSize: "16px", fontWeight: "400", color: "#696A6B" }}
      >
        {subtitle}
      </Typography> */}
      {/* <Box sx={{ display: "flex" }}>
        <Box
          {...getRootPropsMain()}
          sx={{
            mt: 2,
            border: "2px dashed #ccc",
            padding: 3,
            borderRadius: 2,
            textAlign: "center",
            cursor: "pointer",
            height: "200px",
            background: "#fff",
            paddingTop: "40px",
            width: "70%",
            marginRight: "30px",
          }}
        >
          <input {...getInputPropsMain()} />
          <img src={galleryIcon} alt="Gallery Icon" />
          <Typography sx={{ fontSize: "16px" }}>{uploadText}</Typography>
          <Typography sx={{ fontSize: "14px", color: "#7D7E7F" }}>
            {uploadSize}
          </Typography>
        </Box>
      </Box> */}
      {uploadError && (
        <Typography sx={{ color: "red", mt: 1 }}>{uploadError}</Typography>
      )}
      <Box
        onClick={() => handleAction && handleAction(id)}
        sx={{ display: "flex", mt: 2, flexWrap: "wrap" }}
      >
        {renderThumbnails(
          files4.find((entry) => entry.id === mainIdd)?.files || [],
          setFiles4,
          mainIdd
        )}
      </Box>
      <Typography variant="body1" sx={{ display: "flex" }}>
        {imageUrls.length > 0 ? (
          imageUrls.map((url: any, index: any) => (
            <img
              key={index}
              src={url}
              alt={`Image ${index + 1}`}
              className="uploaded-image-preview"
            />
          ))
        ) : (
          <p></p>
        )}
        {note}
      </Typography>
    </Box>
  );
}

export default CreatetaskImg3;